import React, { createRef } from 'react';

import withAppState from '../mobx/withAppState';
import { Steps } from '../lib/constants';
import { fontResizer } from '../helpers/fontResizer.js';

const SecondaryCTA = (props) => {
  const { activeStep, secondaryCTAActive, fontSize, secondaryCTALoadingAnimationActive, secondaryCTAText } = props;
  return activeStep === Steps.BILL
    ? (
      <button
        className={`secondary-cta btn btn-secondary ${secondaryCTAActive === false && 'disabled'}`}
        style={{ fontSize: `${fontSize}px` }}
        onClick={props.secondaryCTA}
      >
        {secondaryCTALoadingAnimationActive === true
          ? <span className="cta-dual-ring"></span>
          : <span>{secondaryCTAText}</span>}
      </button>
    )
    : null
}

const MainCTA = (props) => {
  const { activeStep, fontSize, mainCTAActive, mainCTAText, mainCTALoadingAnimationActive } = props;
  return (
    <button
      className={
        `btn btn-primary btn-checkout `
        + `${activeStep === Steps.BILL ? 'secondary-cta ' : 'main-cta '}`
        + `${mainCTAActive === false ? 'disabled' : ''}`}
      style={{ fontSize: `${fontSize}px` }}
      onClick={() => mainCTAActive === true && props.mainCTA()}
    >
      {mainCTALoadingAnimationActive === true
        ? (<span className="cta-dual-ring"></span>)
        : (<span>{mainCTAText}</span>)}
    </button>
  );
}

class Footer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingAnimation: true
    };
  }

  
  
  componentDidMount() {
    window.addEventListener('resize', () => {
      this.forceUpdate();
    });
  }
  
  render() {

    const {
      activeStep,
      submittingPayment,
      innerWrapper,
    } = this.props;

    if (submittingPayment === true) {
      return null;
    }
    let fontSize = 16;
    if (activeStep === Steps.BILL) {
      fontSize = fontResizer('', 'btn');
      if (fontSize > 16) fontSize = 16;
    }

    if (activeStep === Steps.BILL ||
      activeStep === Steps.APPLY_GRATUITY ||
      activeStep === Steps.PAY ||
      activeStep === Steps.REGISTER) {
      return (
        <div className="footer is-pay is-sticky">
          {innerWrapper === true ? (
            <div className="footer-inner-wrapper">
              <SecondaryCTA {...this.props} fontSize={fontSize} />
              <MainCTA {...this.props} fontSize={fontSize} />
            </div>) : ( 
            <>
              <SecondaryCTA {...this.props} fontSize={fontSize} />
              <MainCTA {...this.props} fontSize={fontSize} />
            </>)}
        </div>
      )
    }
    return null
  }
}

export default withAppState(Footer,
  {
    mobXProps: ({
      submittingPayment,
      activeStep,
      secondaryCTAActive,
      secondaryCTALoadingAnimationActive,
      secondaryCTAText,
      mainCTAActive,
      mainCTALoadingAnimationActive,
      mainCTAText,
    }) => ({
      submittingPayment,
      activeStep,
      secondaryCTAActive,
      secondaryCTALoadingAnimationActive,
      secondaryCTAText,
      mainCTAActive,
      mainCTALoadingAnimationActive,
      mainCTAText,
    }),
    mobXActions: ({
      secondaryCTA,
      mainCTA,
    }) => ({
      secondaryCTA,
      mainCTA,
    })
  }
);